import {
  lensPath,
  set,
} from 'ramda';
import { qualifyKeyPath } from './utils';

export default (state, domain, keyPath, newKey) => {
  const qualifiedPath = qualifyKeyPath(domain, keyPath);
  const lens = lensPath(qualifiedPath);

  return set(lens, newKey, state);
};
